import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { PureComponent } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import { TRANSACTION_TYPES, TRANSACTION_TYPESV2 } from 'src/constants/payments';

const colors = {
  paid: '#82ca9d',
  unpaid: '#ff5e5e',
  credited: '#1f8fff'
};
const CustomTooltip = _ref => {
  let active = _ref.active,
    payload = _ref.payload;
  if (active && payload && payload.length) {
    var _payload$, _unpaid$payload, _payload$2, _credited$payload, _payload$3, _paid$payload, _payload$4;
    const paid = payload.find(i => i.dataKey === 'paid');
    const credited = payload.find(i => i.dataKey === 'credited');
    const unpaid = payload.find(i => i.dataKey === 'unpaid');
    return /*#__PURE__*/React.createElement("div", {
      // className={classes.customTooltip}
      style: {
        backgroundColor: 'hsla(0,0%,100%,0.9)',
        border: '1px solid #f5f5f5',
        padding: '5px',
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("p", {
      className: "label",
      style: {
        padding: 0,
        margin: 0
      }
    }, /*#__PURE__*/React.createElement("b", null, "".concat((_payload$ = payload[0]) === null || _payload$ === void 0 || (_payload$ = _payload$.payload) === null || _payload$ === void 0 ? void 0 : _payload$.periodFullName))), /*#__PURE__*/React.createElement("p", {
      // className={classes.descTotalCurrency}
      style: {
        padding: 0,
        margin: 0,
        color: colors.unpaid
      }
    }, "Total unpaid: $", "".concat(Number(unpaid === null || unpaid === void 0 || (_unpaid$payload = unpaid.payload) === null || _unpaid$payload === void 0 ? void 0 : _unpaid$payload.unpaid).toFixed(2), "/").concat(Number((_payload$2 = payload[0]) === null || _payload$2 === void 0 ? void 0 : _payload$2.payload.percentageOfUnpaid).toFixed(2), "%")), /*#__PURE__*/React.createElement("p", {
      // className={classes.descTotalCurrency}
      style: {
        padding: 0,
        margin: 0,
        color: colors.credited
      }
    }, "Total credited: $", "".concat(Number(credited === null || credited === void 0 || (_credited$payload = credited.payload) === null || _credited$payload === void 0 ? void 0 : _credited$payload.credited).toFixed(2), "/").concat(Number((_payload$3 = payload[0]) === null || _payload$3 === void 0 ? void 0 : _payload$3.payload.percentageOfCredited).toFixed(2), "%")), /*#__PURE__*/React.createElement("p", {
      // className={classes.descTotalCurrency}
      style: {
        padding: 0,
        margin: 0,
        color: colors.paid
      }
    }, "Total paid: $", "".concat(Number(paid === null || paid === void 0 || (_paid$payload = paid.payload) === null || _paid$payload === void 0 ? void 0 : _paid$payload.paid).toFixed(2), "/").concat(Number((_payload$4 = payload[0]) === null || _payload$4 === void 0 ? void 0 : _payload$4.payload.percentageOfPaid).toFixed(2), "%")));
  }
  return null;
};
export default class BarChartPaidUnpaid extends PureComponent {
  constructor(props) {
    super(props);
    this.state = _objectSpread({}, props);
  }
  render() {
    return /*#__PURE__*/React.createElement(ResponsiveContainer, {
      width: "100%",
      height: "100%"
    }, /*#__PURE__*/React.createElement(BarChart, {
      width: 500,
      height: 300,
      data: this.props.data
      // data={data}
      ,
      margin: {
        top: 10,
        right: 15,
        left: 15,
        bottom: 10
      },
      isAnimationActive: false
    }, /*#__PURE__*/React.createElement(CartesianGrid, {
      strokeDasharray: "3 3"
    }), /*#__PURE__*/React.createElement(XAxis, {
      dataKey: "periodName"
    }), /*#__PURE__*/React.createElement(YAxis, {
      tickFormatter: value => {
        return "$".concat(value);
      }
    }), /*#__PURE__*/React.createElement(Tooltip, {
      content: /*#__PURE__*/React.createElement(CustomTooltip, null),
      cursor: {
        fill: 'transparent'
      }
    }), /*#__PURE__*/React.createElement(Legend, null), /*#__PURE__*/React.createElement(Bar, {
      barSize: 20,
      maxBarSize: 35,
      displayName: "Paid",
      name: 'Paid',
      dataKey: "paid",
      stackId: "period",
      fill: colors.paid,
      isAnimationActive: false,
      minPointSize: 3
    }), /*#__PURE__*/React.createElement(Bar, {
      barSize: 20,
      maxBarSize: 35,
      name: 'Credited',
      displayName: "Credited"
      // dataKey="credited"
      ,
      dataKey: "credited",
      stackId: "period",
      fill: colors.credited,
      isAnimationActive: false,
      minPointSize: 3
    }), /*#__PURE__*/React.createElement(Bar, {
      barSize: 20,
      maxBarSize: 35,
      name: 'Unpaid',
      displayName: "Unpaid",
      dataKey: "unpaid",
      stackId: "period",
      fill: colors.unpaid,
      isAnimationActive: false,
      minPointSize: 3
    })));
  }
}